export default __webpack_public_path__ + "static/media/Slide2.2b87144d.jpg";